$ = require 'jquery'
Confirm = require 'views/lib/confirm'
PopOver = require 'views/lib/pop-over'
l = require 'lib/localize'
track = require 'debug/track'

maybeDisplayMemberLimitsError = ($elem, board) ->
  exceededLimitMessage = null
  if board?.isOverLimit('boards', 'totalMembersPerBoard')
    exceededLimitMessage = 'members exceeds total per board limit'

  if exceededLimitMessage?
    track("Invitations", "Denied", exceededLimitMessage)
    Confirm.toggle exceededLimitMessage,
      elem: $elem
      html: l "confirm.#{exceededLimitMessage}.text",
        { boardName: board?.get("name") }
      fxConfirm: (e) =>
        PopOver.hide()
    return true
  return false

module.exports = { maybeDisplayMemberLimitsError }



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/member-limits-error.coffee